import * as types from '../types/activityTypes';

const initialState = {
  loading: false,
  loaded: false,
  error: null,
  votes: [],
  suggestions: [],
  reviews: [],
};

export default function activityReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_MY_ACTIVITY_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_MY_ACTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        votes: action.payload?.votes || [],
        suggestions: action.payload?.suggestions || [],
        reviews: action.payload?.reviews || [],
      };
    case types.FETCH_MY_ACTIVITY_FAILURE:
      return { ...state, loading: false, loaded: false, error: action.payload || null };
    default:
      return state;
  }
}

